module.exports = __webpack_public_path__ + "img/LMS-Courses-0.03e21358.svg";